import { RootState } from "../../../utils/types/root-state";


export const getHeaderNavState = (state: RootState) => state.headerNav;
